<template>
     <div class="modal-card">

                    <b-loading :is-full-page=true v-model="isLoadingFullPage" ></b-loading>
                  
                    <!-- <header class="modal-card-head "  >
       
                            
                       
                    </header> -->



                    <section class="modal-card-body">
                    
                       <b-steps
                                        v-model="activeStep"
                                        rounded
                                        :has-navigation="hasNavigation"
                                        >
                                        <b-step-item step="1" :label="HNLabel"  >
                                            <h1 class="title has-text-centered">1. เลือก HN ที่ต้องการ</h1>
                                        </b-step-item>
                                        
                                        <b-step-item step="2" :label="memberLabel"   >
                                            <h1 class="title has-text-centered">2. Member </h1>
                                        </b-step-item>

                                        <b-step-item step="3" :label="automateOrNonAutomateLabel"   >
                                            <h1 class="title has-text-centered">2. Automate หรือ Non Automate </h1>
                                        </b-step-item>

                                        <b-step-item step="4"  label="Items"  >
                                            <h1 class="title has-text-centered">3. เลือกรายการ  Items</h1>
                                        </b-step-item>

                                        <b-step-item step='5' label="Finish/Summarize"   disabled>
                                            <h1 class="title has-text-centered">4. Finish/Summarize</h1>
                                        </b-step-item>

                               
                                    </b-steps>
              
                    <HNSelection v-if="activeStep==0"   @HNSelected="HNSelected" />
                    <MemberIDSelection v-if="activeStep==1"   @memberIDSelected="memberIDSelected" />
                    <AutomatOrNonAutomate v-if="activeStep==2"  @automateNonAutomateSelected="automateNonAutomateSelected" />
                    <ItemsSelection  v-if="activeStep==3"  @itemsSelected="itemsSelected"  />
                    <FinishCreatePathoService  v-if="activeStep==4" @saveNewCheckinCompleted="saveNewCheckinCompleted" />


                    </section>
                    <footer class="modal-card-foot"  >
                        <b-button type="is-danger" @click="close">Close</b-button>                        
                    </footer>



                    


                   




                </div>

    
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import HNSelection from './HNSelection.vue'
import MemberIDSelection from './MemberIDSelection.vue'
import AutomatOrNonAutomate from './AutomatOrNonAutomate.vue'
import ItemsSelection from './ItemsSelection.vue'
import FinishCreatePathoService from './FinishCreatePathoService.vue'

export default {
    name : "NewCheckInPatho",
    components:{
        HNSelection,
        MemberIDSelection,
        AutomatOrNonAutomate,
        ItemsSelection,
        FinishCreatePathoService,
    },
    props:{
        isShowing : Boolean,
    },
    created() {
            const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
                this.close()
                next(false)
            })

            this.$once('hook:destroyed', () => {
                unregisterRouterGuard()
            })
    },
    computed:{
        ...mapState({
            dataGroupAndDetailAutomate : state => state.patho_opd_job_worklist.dataGroupAndDetailAutomate ,
            dataGroupAndDetailNonAutomate : state => state.patho_opd_job_worklist.dataGroupAndDetailNonAutomate ,

            dvmArr : state => state.patho_opd_job_worklist.dvmArr ,
            deptArr : state => state.patho_opd_job_worklist.deptArr ,


            firstInteract : state => state.patho_opd_job_worklist.firstInteract ,

        }) 
    },  
    methods:{
        ...mapMutations({
             setHNSelected : 'patho_opd_job_worklist/setHNSelected',
             setMemberSelected : 'patho_opd_job_worklist/setMemberSelected',
             setAutomateOrNoneAutomateMode: 'patho_opd_job_worklist/setAutomateOrNoneAutomateMode',
             setItemsSelected: 'patho_opd_job_worklist/setItemsSelected',
             setFirstInteract: 'patho_opd_job_worklist/setFirstInteract',

            // Automate
            setCheckedRowsDetailAutomate : 'patho_opd_job_worklist/setCheckedRowsDetailAutomate',
            setDVMSelectedAutomate: 'patho_opd_job_worklist/setDVMSelectedAutomate',
            setDeptSelectedAutomate  : 'patho_opd_job_worklist/setDeptSelectedAutomate',
            setDVMAutocompleteAutomate: 'patho_opd_job_worklist/setDVMAutocompleteAutomate',
            setDeptAutocompleteAutomate: 'patho_opd_job_worklist/setDeptAutocompleteAutomate',


            // NonAutomate
            setCheckedRowsDetailNonAutomate : 'patho_opd_job_worklist/setCheckedRowsDetailNonAutomate',
            setDVMSelectedNonAutomate: 'patho_opd_job_worklist/setDVMSelectedNonAutomate',
            setDeptSelectedNonAutomate  : 'patho_opd_job_worklist/setDeptSelectedNonAutomate',
            setDVMAutocompleteNonAutomate: 'patho_opd_job_worklist/setDVMAutocompleteNonAutomate',
            setDeptAutocompleteNonAutomate: 'patho_opd_job_worklist/setDeptAutocompleteNonAutomate',


            
   

        }),
        ...mapActions({
             fetchDataGroupAndDetailAutomate : 'patho_opd_job_worklist/fetchDataGroupAndDetailAutomate',
             fetchDataGroupAndDetailNonAutomate : 'patho_opd_job_worklist/fetchDataGroupAndDetailNonAutomate',

             fetchDVMArr : 'patho_opd_job_worklist/fetchDVMArr',
             fetchDeptArr : 'patho_opd_job_worklist/fetchDeptArr',
        }),
       close(){
        this.$emit('close')
       },


       HNSelected(payload){
         this.setHNSelected(payload)
         this.HNLabel = `HN ${payload.idopd}/${payload.name.substring(0, 20)}`
         this.activeStep = 1
       },
       memberIDSelected(payload){
         this.setMemberSelected(payload)
         this.memberLabel = `Member ${payload.name.substring(0, 20)}`
         this.activeStep = 2
       },
       automateNonAutomateSelected(payload){
         this.setAutomateOrNoneAutomateMode(payload)
         this.automateOrNonAutomateLabel = payload == 0 ? 'Automate' : 'Non Automate'
         this.activeStep = 3
       },
       itemsSelected(payload){
         this.setItemsSelected(payload)
         this.activeStep = 4
       },
       saveNewCheckinCompleted(payload){
          const tmpTxtLabID_LOR =  payload.automate_mode == 0  ? payload.idlab : payload.lor
          this.$buefy.dialog.alert({
                    title: 'Completed',
                    message: `JobID :${payload.visit_no} <br/> 
                              Lab/Order ID :  ${tmpTxtLabID_LOR}`,
                    confirmText: 'Cool!'
                })
          this.$emit('closeWithUpdate')
       },

    async   initState(){
       this.isLoadingFullPage = true 
       await  this.fetchDataGroupAndDetailAutomate()
       await  this.fetchDataGroupAndDetailNonAutomate()
       await  this.fetchDVMArr()
       await  this.fetchDeptArr()


       // clear all state except search opd
       this.setHNSelected(null)
       this.setAutomateOrNoneAutomateMode(null) 
       this.setItemsSelected([])
       this.isLoadingFullPage = false

       //  set first interact -> false  
       this.setFirstInteract(false)


       // Automate
       this.setCheckedRowsDetailAutomate([])
       this.setDVMSelectedAutomate(null)
       this.setDeptSelectedAutomate(null)   
       this.setDVMAutocompleteAutomate('') 
       this.setDeptAutocompleteAutomate('') 
       // NonAutomate
       this.setCheckedRowsDetailNonAutomate([])
       this.setDVMSelectedNonAutomate(null) 
       this.setDeptSelectedNonAutomate(null) 
       this.setDVMAutocompleteNonAutomate('') 
       this.setDeptAutocompleteNonAutomate('') 

       // member id
       this.setMemberSelected(null) 

       }


    },
    data(){
        return {
            isLoadingFullPage : false,
            activeStep: 0,
            hasNavigation : false,
            HNLabel : "HN",
            memberLabel: "Member",
            automateOrNonAutomateLabel : "Automate หรือ NonAutomate",
            automateOrNonAutomate : 0 , // 0 == automate , 1 == non automate
        }
    },
    watch:{
        isShowing:{
            immediate: true,
            handler: function(val){
               if(val){

                if(this.firstInteract){
                    this.initState()
                }



                // if not first
                // but used for new checkin normal(not first may second time etc...)
                this.setCheckedRowsDetailAutomate([])
                this.setDVMSelectedAutomate(null)
                this.setDeptSelectedAutomate(null)   
                this.setDVMAutocompleteAutomate('') 
                this.setDeptAutocompleteAutomate('') 


                this.setCheckedRowsDetailNonAutomate([])
                this.setDVMSelectedNonAutomate(null) 
                this.setDeptSelectedNonAutomate(null) 
                this.setDVMAutocompleteNonAutomate('') 
                this.setDeptAutocompleteNonAutomate('') 


                this.setItemsSelected([])
               
                this.setMemberSelected(null) 



               }
            }
        }
    }
}
</script>